import type { UturnUserRequest } from '@uturn/api/v1';
import { z } from '@uturn/portal/zod';

const notificationEmailEntrySchema = z.object({
	email: z.preprocess(
		(value) => (typeof value === 'string' ? value.trim() : value),
		z.string().email().or(z.literal('')),
	),
});

/** @see UturnUserRequest */
export const formNotificationsSchema = z
	.object({
		notificationEmails: notificationEmailEntrySchema.array(),
	})
	.passthrough();

export type TForm = Omit<UturnUserRequest, 'notificationEmails'> & {
	notificationEmails: { email: string }[];
};
